
import { Component, Vue } from "vue-property-decorator";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import FaqSection from "@/components/FaqSection.vue";
import { getItemListJsonLd, injectJsonLd } from "@/utils/seo";

@Component({
  components: { Breadcrumb, FaqSection }
})
export default class ScientificManagement extends Vue {
  relatedServices = [
    { name: "咨询陪跑", url: "/accompany", desc: "6-12个月全程陪伴，将科学经营™方法论落地到企业日常经营" },
    { name: "光华大增长营", url: "/big-growth-camp", desc: "系统学习科学经营™方法论，掌握BLM+分拆对™的实战应用" },
    { name: "实战EMBA", url: "/co-creation-club/academy", desc: "面向企业创始人的高阶经营管理课程，融入科学经营™核心体系" }
  ];

  mounted() {
    injectJsonLd(
      "jsonld-related-services",
      getItemListJsonLd(
        this.relatedServices.map((s) => ({
          name: s.name,
          url: s.url
        }))
      )
    );
  }
  breadcrumbList = [
    { title: "首页", url: "/" },
    { title: "关于光华", url: "/about" },
    { title: "科学经营™" }
  ];

  faqList = [
    { question: "科学经营™是什么？", answer: "科学经营™是光华赋能经过20余年企业经营研究独创的方法论体系，以BLM科学经营方法论和分拆对™工作法为两大支柱，帮助企业从野蛮生长走向科学经营，实现高质量发展。" },
    { question: "科学经营™适合什么企业？", answer: "适合所有希望提升经营管理水平、实现可持续增长的成长型企业，尤其适合遇到增长瓶颈、需要从经验管理转向科学管理的企业。" },
    { question: "如何学习科学经营™？", answer: "可通过光华大增长营、科研院、实战EMBA等课程系统学习，也可通过咨询陪跑服务在企业实践中落地应用。" },
    { question: "科学经营™与传统管理培训有什么区别？", answer: "科学经营™不只是理论知识传授，更强调方法论+工作法+落地执行的三位一体，通过咨询陪跑和数字化系统确保方法论真正转化为经营成果。" }
  ];
}
